import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NxPosButtonComponent } from './nx-pos-button.component';
import { FlexLayoutModule } from '@angular/flex-layout';



@NgModule({
  declarations: [
    NxPosButtonComponent
  ],
  imports: [
    CommonModule,
    FlexLayoutModule
  ],
  exports: [
    NxPosButtonComponent
  ]
})
export class NxPosButtonModule { }
